const actions = {
    LOCAL_STORAGE_SELECT_COLUMNS: "LOCAL_STORAGE_SELECT_COLUMNS",
    LOCAL_STORAGE_SET_COLUMN_WIDTH: "LOCAL_STORAGE_SET_COLUMN_WIDTH",
    LOCAL_STORAGE_SET_SORT_PARAMS: "LOCAL_STORAGE_SET_SORT_PARAMS",
    LOCAL_STORAGE_SET_PAGE_SIZE: "LOCAL_STORAGE_SET_PAGE_SIZE",
    LOCAL_STORAGE_SET_REPORT_LABEL: "LOCAL_STORAGE_SET_REPORT_LABEL",
    LOCAL_STORAGE_SET_REPORT_REMARKS: "LOCAL_STORAGE_SET_REPORT_REMARKS",

    LOCAL_STORAGE_TOGGLE_STAR_REPORT: 'LOCAL_STORAGE_TOGGLE_STAR_REPORT',
    LOCAL_STORAGE_SET_COLLAPSE_REPORT: 'LOCAL_STORAGE_SET_COLLAPSE_REPORT',

    selectColumns: (key, columnKeys) => ({
        type: actions.LOCAL_STORAGE_SELECT_COLUMNS,
        key,
        columnKeys,
    }),
    setColumnWidth: (key, columnKey, width) => ({
        type: actions.LOCAL_STORAGE_SET_COLUMN_WIDTH,
        key,
        columnKey,
        width,
    }),
    setSortParams: (key, sorter) => ({
        type: actions.LOCAL_STORAGE_SET_SORT_PARAMS,
        key,
        sorter,
    }),
    setPageSize: (key, pageSize) => ({
        type: actions.LOCAL_STORAGE_SET_PAGE_SIZE,
        key,
        pageSize,
    }),
    setReportLabel: (key, reportLabel) => ({
        type: actions.LOCAL_STORAGE_SET_REPORT_LABEL,
        key,
        reportLabel,
    }),
    setReportRemarks: (key, reportRemarks) => ({
        type: actions.LOCAL_STORAGE_SET_REPORT_REMARKS,
        key,
        reportRemarks,
    }),
    toggleStarReport: report => ({
        type: actions.LOCAL_STORAGE_TOGGLE_STAR_REPORT,
        report,
    }),
    setCollapseReport: item => ({
        type: actions.LOCAL_STORAGE_SET_COLLAPSE_REPORT,
        item,
    }),
};
export default actions;
